import React from "react";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "bootstrap/scss/bootstrap.scss";
import "./assets/scss/paper-kit.scss?v=1.3.0";
import TopRangeIndex from "./views/TopRangeIndex";
import TopRangeLegalNotices from "./views/TopRangeLegalNotices";
import TopRangeFeedback from "./views/TopRangeFeedback";
import TopRangeWorkEnvironment from "./views/TopRangeWorkEnvironment";


const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/index" element={<TopRangeIndex />} />
      <Route path="/feedback" element={<TopRangeFeedback />} />
      <Route path="/work-environment" element={<TopRangeWorkEnvironment />} />
      <Route path="/apps-privacy-notices" element={<TopRangeLegalNotices />} />
      <Route path="*" element={<Navigate to="/index" replace />} />
    </Routes>
  </BrowserRouter>
);
